import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { ToggleIsClientModalData } from './toggle.is.client.modal.provider';

@Component({
    templateUrl: './toggle.is.client.modal.component.html',
    styleUrls: ['./toggle.is.client.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ToggleIsClientModalComponent extends BaseComponent {
    public loading = false;
    public account: ToggleIsClientModalData;
    @ViewChild('success') success: SuccessWrapComponent;

    constructor(private fb: FormBuilder,
                private accountApiService: AccountApiService,
                private dialogRef: MatDialogRef<ToggleIsClientModalComponent>,
                data: ToggleIsClientModalData) {
        super();
        this.account = Object.assign({}, data);
    }

    ngOnInit() {
        this.loading = true;
        this.accountApiService.getIsClient(this.account.account._id).subscribe(toggle => {
            if (toggle) {
                this.account.account.isClientAccount = isNullOrUndefined(toggle.isClientAccount) ? true : toggle.isClientAccount;
            }

            this.loading = false;
        });
    }

    public toggleIsClientAccount() {
        this.account.account.isClientAccount = !this.account.account.isClientAccount;
        this.accountApiService.toggleIsClientAccount(this.account.account._id, this.account.account.isClientAccount).subscribe(data => {
            this.success.success();
        });
    }

    close() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/toggle.is.client/toggle.is.client.modal.component.ts